import SearchBox from "./SearchBox";
import NotificationDropBox from "./NotificationDropBox";
import { LI, SVG, UL } from "../../AbstractElements";
import { DarkButton } from "./DarkButton";
import Bookmarks from "./Bookmark";
import { Badge } from "reactstrap";
import { Meassage } from "./Meassage";
import { Cart } from "./Cart/Cart";
import { Language } from "./Language";
import Profile from "./Bookmark/Profile";
import { useAppDispatch } from "../../Redux-Toolkit/Hooks";
import { setBookmarkDropDown } from "../../Redux-Toolkit/Reducers/BookmarkSlice";

const NavMenu = () => {
  const dispatch = useAppDispatch();
  return (
    <UL className="nav-menus d-flex flex-row simple-list">
      <SearchBox />
      <LI className="onhover-dropdown">
        <div className="notification-box animated">
          <SVG iconId="notification" />
        </div>
        <NotificationDropBox />
      </LI>
      <LI>
        <DarkButton />
      </LI>
      <LI className="onhover-dropdown" onClick={() => dispatch(setBookmarkDropDown())}>
        <SVG iconId="star" />
        <Bookmarks />
      </LI>
      <LI className="onhover-dropdown">
        <div className="notification-box">
          <SVG iconId="Message" />
          <Badge pill color="secondary"></Badge>
        </div>
        <Meassage />
      </LI>
      <LI className="cart-nav onhover-dropdown">
        <div className="cart-box">
          <SVG iconId="stroke-ecommerce" />
        </div>
        <Cart />
      </LI>
      <Language />
      <LI className="profile-nav onhover-dropdown pe-0 py-0">
        <Profile />
      </LI>
    </UL>
  );
};

export default NavMenu;
